import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class RepeaterValidationStrategy extends ValidationStrategy {
    private errorMessage: string = "";
    private minimumAmountFailed: boolean;
    private maximumAmountFailed: boolean;

    public validate(): boolean {
        let isValid = true;
        let itemsAttr = this.attribute.attributes
            .find(attr => attr.type.toLowerCase() == "items");

        let minAmount = this.attribute.options
            .find(option => option.key.toLowerCase() == 'minimumamount');

        if(minAmount) {
            if(!itemsAttr) {
                this.minimumAmountFailed = true;
                isValid = false;
            } else {
                isValid = itemsAttr.attributes.length >= +minAmount.value;
            }
         }

        if(!isValid) {
            this.minimumAmountFailed = true;
            isValid = false;
        }

        let maxAmount = this.attribute.options
            .find(option => option.key.toLowerCase() == 'maximumamount');

        if(maxAmount) {
            if(!itemsAttr) {
                this.maximumAmountFailed = true;
                isValid = false;
            } else {
                isValid = itemsAttr.attributes.length <= +maxAmount.value;
            }
        }

        if(!isValid) {
            this.maximumAmountFailed = true;
            isValid = false;
        }

        if (isValid && itemsAttr) {
            itemsAttr.attributes.forEach(attr => {
                let validator = ValidationStrategyFactory.create(attr, this.injectedOptions);
                let childrenAreValid = validator.validate();
    
                if(!childrenAreValid) {
                    this.errorMessage += `${validator.getErrorMessage()}\n`;
                }
    
                isValid = childrenAreValid && isValid;
            });   
        }

        this.attribute.hasError = !isValid

        return isValid;
    }

    public getErrorMessage(errorType: string = "error") {
        if (this.errorMessage) {
            return this.errorMessage;
        }
        
        let fieldName = this.attribute.key;

        let titleOpt = this.attribute.options
            .find(opt => opt.key.toLowerCase() == "title");

        if (titleOpt) {
            fieldName = titleOpt.value;
        }

        if (this.minimumAmountFailed) {
            errorType = "MinimumAmountError";
        } else if (this.maximumAmountFailed) {
            errorType = "MaximumAmountError";
        }

        let errorOpt = this.attribute.options
            .find(opt => opt.key.toLowerCase() == errorType.toLowerCase());

        return errorOpt ? errorOpt.value : `O campo "${fieldName}" não foi preenchido corretamente.`;
    }
}